import styled from '@emotion/styled'
import BaseTitle from '@organisms/Title'
import { isMobile } from '@const/device'

export const BlockWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Больше отступ от блока выше (Сортировка) до заголовка "Доступность". */
  margin-top: 44px;
`

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: ${() => (isMobile ? 'column' : 'row')};
  align-items: ${() => (isMobile ? 'flex-start' : 'flex-end')};
  gap: 24px;
`

export const SelectWrapper = styled.div`
  width: ${() => (isMobile ? '85vw' : '260px')};
  min-width: 0;
`

export const SelectLabel = styled.div`
  height: 30px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
  font-size: ${({ theme }) => theme.text.h6.fontSize};
  line-height: ${({ theme }) => theme.text.h6.lineHeight};
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  text-transform: uppercase;
`

export const DeleteWrapper = styled.div`
  flex-shrink: 0;
`

export const AddButtonWrapper = styled.div`
  width: fit-content;
  margin-top: 4px;
`

export const ErrorText = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
`

export const StyledTitle = styled(BaseTitle)`
  /* Заголовок "Доступность" относится к Компания/Филиал ниже — притягиваем к ним
     (компенсируем gap:20px родителя, итоговый отступ до первой строки ~8px). */
  margin-bottom: -12px;
`
